const LIST_PATH = '/popups';

/** The route block popups lived at before they took over `/popups`. */
export const LEGACY_BLOCK_POPUPS_LIST_PATH = '/block-popups';

export const BLOCK_POPUP_PATHS = {
  AB_TESTS: `${LIST_PATH}/ab-tests`,
  AB_TESTS_CREATE: `${LIST_PATH}/ab-tests/create`,
  CREATE: `${LIST_PATH}/create`,
  CREATE_SPLIT_TEST: `${LIST_PATH}/create_split_test`,
  EDITOR: `${LIST_PATH}/editor`,
  EDIT_SPLIT_TEST: `${LIST_PATH}/edit_split_test`,
  INFINITY_TESTS: `${LIST_PATH}/infinity-tests`,
  INFINITY_TESTS_REVIEW_QUEUE: '/review-queue',
  LIST: LIST_PATH,
  SCHEDULE: `${LIST_PATH}/schedule`,
} as const;

export const BLOCK_POPUPS_QUERY_KEY_PREFIX = 'block-popups';
export const BLOCK_POPUPS_GROUP_TESTS_QUERY_KEY_PREFIX =
  'block-popups/group-tests';
export const BLOCK_POPUPS_SPLIT_TESTS_QUERY_KEY_PREFIX =
  'block-popups/split-tests';
export const BLOCK_POPUPS_INFINITY_TESTS_QUERY_KEY_PREFIX = 'infinity-tests';
export const SCHEDULE_EVENTS_QUERY_KEY_PREFIX = 'schedule-events';

export const SPLIT_TEST_TOOLTIP_MESSAGE =
  'There must be at least two available popups to create an A/B test. Create a new popup or clone an existing one, make the changes you want to test, and try again.';

export const INFINITY_TEST_STATUSES = {
  GENERATING: 'generating',
  REVIEWING: 'reviewing',
  READY: 'ready',
  RUNNING: 'running',
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
} as const;

export const INFINITY_TEST_VARIANT_STATUSES = {
  ACTIVE: 'active',
  APPROVED: 'approved',
  PENDING: 'pending',
  REJECTED: 'rejected',
  WINNER: 'winner',
} as const;

// Derived per-variant running status from the API (`test_status`).
export const INFINITY_TEST_VARIANT_TEST_STATUSES = {
  NOT_TESTED: 'not_tested',
  QUEUED: 'queued',
  ACTIVE: 'active',
  CANDIDATE: 'candidate',
  LOSER: 'loser',
  WINNER: 'winner',
} as const;

export const LIST_BREADCRUMB_TEXT = 'Website Popups';
